var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';
import CustomButton from '../../../components/buttonComponent/CustomButton';
import ConfirmationAndInformationPoup, { POPUP_TYPE, } from '../../../components/UtilityComponents/ConfirmationAndInformationPoup';
import { dynamicCheckboxSx, MultiRecordFormTabs, useDynamicFormOverrides, } from '../../../components/FormComponents/dynamicForm';
import { buildGuarantorSections, CREATE_APPLICATION_STEP_ID, getGuarantorRecordLabel, GUARANTOR_ALWAYS_EDITABLE_FIELD_NAMES, GUARANTOR_ASPIRE_FIELD, GUARANTOR_FIELD, GUARANTOR_LOOKUP_KEY, GUARANTOR_SECTION_ID, } from '../config/create_application_schema';
import { createGuarantorTaxIdLookup } from '../guarantor_lookup_service';
import { useExistingContactSlots } from './ExistingContactSelection';
import SignerGuarantorPreview from './SignerGuarantorPreview';
import { WIZARD_COLORS } from '../../../components/FormComponents/dynamicForm';
import constants from '../../../config/constants';
import { utility } from '../../../utils';
var OWNERSHIP_SUM_ERROR_MESSAGE = "Guarantors' Percent Ownership adds up to more than 100%. Please correct it before continuing.";
var FIRST_RECORD_INDEX = 0;
var shiftRecordIndexMap = function (map, removedIndex) {
    return Object.entries(map).reduce(function (next, _a) {
        var key = _a[0], value = _a[1];
        var index = Number(key);
        if (index !== removedIndex) {
            next[index > removedIndex ? index - 1 : index] = value;
        }
        return next;
    }, {});
};
var INCLUDE_GUARANTOR_SX = {
    marginLeft: 0,
    mb: 0.5,
};
var INCLUDE_GUARANTOR_NOTE_SX = {
    fontSize: 13,
    color: WIZARD_COLORS.muted,
    marginLeft: '4px',
    mb: 1.5,
};
var answeredFieldNames = function (values) {
    return Object.keys(values).filter(function (fieldName) {
        var value = values[fieldName];
        return value !== '' && value !== null && value !== undefined;
    });
};
var SIGNER_FIELD_NAMES = {
    contactAspireOId: GUARANTOR_ASPIRE_FIELD.SignerContactAspireOId,
    firstName: GUARANTOR_FIELD.SignerFirstName,
    middleName: GUARANTOR_FIELD.SignerMiddleName,
    lastName: GUARANTOR_FIELD.SignerLastName,
    suffix: GUARANTOR_FIELD.SignerSuffix,
    title: GUARANTOR_FIELD.SignerTitle,
    email: GUARANTOR_FIELD.SignerEmail,
    phone: GUARANTOR_FIELD.SignerPhone,
};
var GuarantorInformationStep = React.forwardRef(function (_a, ref) {
    var isCanadaProgram = _a.isCanadaProgram, signerGuarantors = _a.signerGuarantors, customerOptions = _a.customerOptions, vendorConfig = _a.vendorConfig;
    var _b = React.useState(false), isGuarantorIncluded = _b[0], setIsGuarantorIncluded = _b[1];
    var isGuarantorMandatedByVendor = Boolean(vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.IsAppGurSectionRequired);
    React.useEffect(function () {
        if (isGuarantorMandatedByVendor) {
            setIsGuarantorIncluded(true);
        }
    }, [isGuarantorMandatedByVendor]);
    var _c = React.useState(null), resetRecordIndex = _c[0], setResetRecordIndex = _c[1];
    var _d = React.useState({}), prefilledRecords = _d[0], setPrefilledRecords = _d[1];
    var recordsRef = React.useRef(null);
    var _e = React.useState(0), activeRecordIndex = _e[0], setActiveRecordIndex = _e[1];
    var _f = React.useState({}), lockedFieldsByRecord = _f[0], setLockedFieldsByRecord = _f[1];
    var getLockedFieldNames = React.useCallback(function (recordIndex) { return lockedFieldsByRecord[recordIndex]; }, [lockedFieldsByRecord]);
    var matchConfirmResolveRef = React.useRef(null);
    var _g = React.useState(false), isMatchConfirmationOpen = _g[0], setIsMatchConfirmationOpen = _g[1];
    var confirmMatch = React.useCallback(function () {
        var _a;
        (_a = matchConfirmResolveRef.current) === null || _a === void 0 ? void 0 : _a.call(matchConfirmResolveRef, false);
        return new Promise(function (resolve) {
            matchConfirmResolveRef.current = resolve;
            setIsMatchConfirmationOpen(true);
        });
    }, []);
    var resolveMatchConfirmation = React.useCallback(function (confirmed) {
        var _a;
        (_a = matchConfirmResolveRef.current) === null || _a === void 0 ? void 0 : _a.call(matchConfirmResolveRef, confirmed);
        matchConfirmResolveRef.current = null;
        setIsMatchConfirmationOpen(false);
    }, []);
    var removeConfirmResolveRef = React.useRef(null);
    var _h = React.useState(false), isRemoveConfirmationOpen = _h[0], setIsRemoveConfirmationOpen = _h[1];
    var confirmRemoveGuarantor = React.useCallback(function () {
        var _a;
        (_a = removeConfirmResolveRef.current) === null || _a === void 0 ? void 0 : _a.call(removeConfirmResolveRef, false);
        return new Promise(function (resolve) {
            removeConfirmResolveRef.current = resolve;
            setIsRemoveConfirmationOpen(true);
        });
    }, []);
    var handleRecordRemoved = React.useCallback(function (recordIndex) {
        setLockedFieldsByRecord(function (previous) { return shiftRecordIndexMap(previous, recordIndex); });
        setPrefilledRecords(function (previous) { return shiftRecordIndexMap(previous, recordIndex); });
    }, []);
    var resolveRemoveConfirmation = React.useCallback(function (confirmed) {
        var _a;
        (_a = removeConfirmResolveRef.current) === null || _a === void 0 ? void 0 : _a.call(removeConfirmResolveRef, confirmed);
        removeConfirmResolveRef.current = null;
        setIsRemoveConfirmationOpen(false);
    }, []);
    var lockAnsweredFields = React.useCallback(function (recordIndex, values) {
        if (recordIndex === undefined || recordIndex === null) {
            return;
        }
        var newlyAnswered = answeredFieldNames(values).filter(function (fieldName) { return !GUARANTOR_ALWAYS_EDITABLE_FIELD_NAMES.includes(fieldName); });
        if (newlyAnswered.length === 0) {
            return;
        }
        setLockedFieldsByRecord(function (previous) {
            var _a;
            var _b;
            return (__assign(__assign({}, previous), (_a = {}, _a[recordIndex] = Array.from(new Set(__spreadArray(__spreadArray([], ((_b = previous[recordIndex]) !== null && _b !== void 0 ? _b : []), true), newlyAnswered, true))), _a)));
        });
    }, []);
    var hasSignerGuarantor = signerGuarantors.length > 0;
    var signerGuarantorTabs = React.useMemo(function () {
        return signerGuarantors.map(function (signerGuarantor, signerIndex) { return ({
            id: "guarantor-signer-".concat(signerIndex),
            label: getGuarantorRecordLabel(signerIndex),
            content: React.createElement(SignerGuarantorPreview, { guarantors: [signerGuarantor] }),
        }); });
    }, [signerGuarantors]);
    var getRecordLabel = React.useCallback(function (recordIndex) { return getGuarantorRecordLabel(recordIndex + signerGuarantors.length); }, [signerGuarantors.length]);
    var _j = useExistingContactSlots({
        recordsRef: recordsRef,
        sectionId: GUARANTOR_SECTION_ID.AuthorizedSigner,
        signerFields: SIGNER_FIELD_NAMES,
    }), beginContactsReport = _j.beginContactsReport, getSectionSlots = _j.getSectionSlots, clearContacts = _j.clearContacts;
    var lookupHandlers = React.useMemo(function () {
        var _a;
        var findGuarantorByTaxId = createGuarantorTaxIdLookup(beginContactsReport, confirmMatch);
        return _a = {},
            _a[GUARANTOR_LOOKUP_KEY.ExistingGuarantorByTaxId] = function (taxId, formValues) { return __awaiter(void 0, void 0, void 0, function () {
                var recordIndex, matched;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            recordIndex = (_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getActiveRecordIndex()) !== null && _b !== void 0 ? _b : FIRST_RECORD_INDEX;
                            return [4, findGuarantorByTaxId(taxId, formValues)];
                        case 1:
                            matched = _c.sent();
                            if (matched) {
                                setPrefilledRecords(function (previous) {
                                    var _a;
                                    return (__assign(__assign({}, previous), (_a = {}, _a[recordIndex] = true, _a)));
                                });
                                lockAnsweredFields(recordIndex, matched);
                            }
                            return [2, matched];
                    }
                });
            }); },
            _a;
    }, [beginContactsReport, confirmMatch, lockAnsweredFields]);
    var handleResetRecord = React.useCallback(function (recordIndex) {
        var _a;
        var _b, _c, _d, _e;
        var guarantorType = (_c = (_b = recordsRef.current) === null || _b === void 0 ? void 0 : _b.getRecords()[recordIndex]) === null || _c === void 0 ? void 0 : _c[GUARANTOR_FIELD.GuarantorType];
        (_d = recordsRef.current) === null || _d === void 0 ? void 0 : _d.resetRecord(recordIndex);
        clearContacts(recordIndex);
        if (guarantorType !== undefined) {
            (_e = recordsRef.current) === null || _e === void 0 ? void 0 : _e.mergeRecord(recordIndex, (_a = {},
                _a[GUARANTOR_FIELD.GuarantorType] = guarantorType,
                _a));
        }
        setPrefilledRecords(function (previous) {
            var _a;
            return (__assign(__assign({}, previous), (_a = {}, _a[recordIndex] = false, _a)));
        });
        setLockedFieldsByRecord(function (previous) {
            var next = __assign({}, previous);
            delete next[recordIndex];
            return next;
        });
        setResetRecordIndex(null);
    }, [clearContacts]);
    var handleFieldChange = React.useCallback(function (recordIndex, fieldName) {
        if (fieldName !== GUARANTOR_FIELD.GuarantorType) {
            return;
        }
        setLockedFieldsByRecord(function (previous) {
            if (!(recordIndex in previous)) {
                return previous;
            }
            var next = __assign({}, previous);
            delete next[recordIndex];
            return next;
        });
        setPrefilledRecords(function (previous) {
            if (!(recordIndex in previous)) {
                return previous;
            }
            var next = __assign({}, previous);
            delete next[recordIndex];
            return next;
        });
    }, []);
    var resetActiveRecordButton = prefilledRecords[activeRecordIndex] ? (React.createElement(CustomButton, { variant: "secondary", SMButton: true, fullWidth: false, startIcon: React.createElement(CachedIcon, { sx: { fontSize: 15 } }), onClick: function () { return setResetRecordIndex(activeRecordIndex); }, sx: { flexShrink: 0, mb: 0.5 } }, "Reset Form")) : undefined;
    var resolveSections = useDynamicFormOverrides().resolveSections;
    var getSections = React.useCallback(function () {
        var schemaSections = buildGuarantorSections(isCanadaProgram, customerOptions);
        if (!resolveSections) {
            return schemaSections;
        }
        return resolveSections(CREATE_APPLICATION_STEP_ID.GuarantorInformation, schemaSections);
    }, [customerOptions, isCanadaProgram, resolveSections]);
    var collectsGuarantors = isGuarantorIncluded || hasSignerGuarantor;
    var totalOwnershipPercentage = React.useCallback(function () {
        var _a, _b;
        var editableTotal = ((_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getRecords()) !== null && _b !== void 0 ? _b : []).reduce(function (sum, record) { return sum + (Number(record[GUARANTOR_FIELD.OwnershipPercentage]) || 0); }, 0);
        var signerTotal = signerGuarantors.reduce(function (sum, signerGuarantor) { return sum + (Number(signerGuarantor.ownership) || 0); }, 0);
        return editableTotal + signerTotal;
    }, [signerGuarantors]);
    React.useImperativeHandle(ref, function () { return ({
        validate: function () {
            var _a, _b;
            if (!collectsGuarantors) {
                return true;
            }
            var areRecordsValid = (_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.validate()) !== null && _b !== void 0 ? _b : true;
            if (!areRecordsValid) {
                return false;
            }
            if (totalOwnershipPercentage() > 100) {
                utility.alert(OWNERSHIP_SUM_ERROR_MESSAGE, constants.TOAST_TYPES.WARN);
                return false;
            }
            return true;
        },
        getPayload: function () {
            var _a, _b;
            return ({
                guarantorInformation: {
                    isGuarantorIncluded: collectsGuarantors,
                    guarantors: collectsGuarantors ? (_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getRecords()) !== null && _b !== void 0 ? _b : [] : [],
                },
            });
        },
        getFiles: function () { var _a, _b; return (collectsGuarantors ? (_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getFiles()) !== null && _b !== void 0 ? _b : {} : {}); },
        reset: function () { var _a; return (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.reset(); },
        getPreview: function () {
            var _a, _b;
            return collectsGuarantors
                ? {
                    label: 'Guarantor Information',
                    records: ((_b = (_a = recordsRef.current) === null || _a === void 0 ? void 0 : _a.getRecords()) !== null && _b !== void 0 ? _b : []).map(function (values, index) { return ({
                        label: getRecordLabel(index),
                        sections: getSections(),
                        values: values,
                    }); }),
                }
                : null;
        },
    }); }, [collectsGuarantors, getRecordLabel, getSections, totalOwnershipPercentage]);
    return (React.createElement(Box, null,
        !hasSignerGuarantor && (React.createElement(React.Fragment, null,
            React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { size: "small", sx: dynamicCheckboxSx, checked: isGuarantorIncluded, disabled: isGuarantorMandatedByVendor, onChange: function (event) { return setIsGuarantorIncluded(event.target.checked); } }), sx: INCLUDE_GUARANTOR_SX, label: React.createElement(Typography, { sx: { fontSize: 14, color: WIZARD_COLORS.ink } }, "Include Guarantor Information?") }),
            React.createElement(Typography, { sx: INCLUDE_GUARANTOR_NOTE_SX }, isGuarantorMandatedByVendor
                ? 'This program requires guarantor details on every application.'
                : 'Check this box to enter guarantor details (optional).'))),
        (isGuarantorIncluded || hasSignerGuarantor) && (React.createElement(React.Fragment, null,
            React.createElement(MultiRecordFormTabs, { ref: recordsRef, idPrefix: "guarantor", getSections: getSections, getRecordLabel: getRecordLabel, addLabel: "Add Guarantor", lookupHandlers: lookupHandlers, getSectionSlots: getSectionSlots, getLockedFieldNames: getLockedFieldNames, leadingTabs: signerGuarantorTabs, initialRecordCount: hasSignerGuarantor ? 0 : 1, isPrimaryRemovable: true, onRemoveLastRecord: isGuarantorMandatedByVendor
                    ? undefined
                    : function () {
                        setIsGuarantorIncluded(false);
                        setLockedFieldsByRecord({});
                        setPrefilledRecords({});
                    }, onActiveRecordChange: setActiveRecordIndex, confirmRemoveRecord: confirmRemoveGuarantor, onRecordRemoved: handleRecordRemoved, onFieldChange: handleFieldChange, trailingContent: resetActiveRecordButton }),
            React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, open: resetRecordIndex !== null, titleText: "Confirm Reset", message: 'Are you sure you want to reset the guarantor details? All ' +
                    "auto-populated information will be reset and you'll need to " +
                    'enter details again.', acceptBtnText: "Reset", acceptCallBack: function () {
                    return resetRecordIndex !== null && handleResetRecord(resetRecordIndex);
                }, denyBtnText: "Cancel", denyCallBack: function () { return setResetRecordIndex(null); }, cancelCallBack: function () { return setResetRecordIndex(null); } }),
            React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.DELETE_CONFIRMATION_WARNING, open: isRemoveConfirmationOpen, titleText: "Are you sure?", message: "This guarantor and any contacts linked to it will be removed from the application.", acceptBtnText: "Delete", acceptCallBack: function () { return resolveRemoveConfirmation(true); }, denyBtnText: "Cancel", denyCallBack: function () { return resolveRemoveConfirmation(false); }, cancelCallBack: function () { return resolveRemoveConfirmation(false); } }),
            React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.UNSAVED_DATA_WARNING, open: isMatchConfirmationOpen, titleText: "Match Found", message: "We found a match in our system. The fields below will be pre-populated with the existing guarantor information.", acceptBtnText: "Yes", acceptCallBack: function () { return resolveMatchConfirmation(true); }, denyBtnText: "No", denyCallBack: function () { return resolveMatchConfirmation(false); }, cancelCallBack: function () { return resolveMatchConfirmation(false); } })))));
});
GuarantorInformationStep.displayName = 'GuarantorInformationStep';
export default GuarantorInformationStep;
